/** @format */

import {GraphSensorCheckFromQuery} from '../../models/api';
import {SensorsList} from './types';
import {processDataFromQuery} from './processDataFromQuery';
import {aggregateSensors} from './aggregateSensors';
import {sortDetailed} from './sortDetailed';

const mapSensors = (
  graphSensorChecks: ReadonlyArray<GraphSensorCheckFromQuery>,
  discreteDates: string[],
): SensorsList => {
  const processed = processDataFromQuery(graphSensorChecks);
  const aggregated = aggregateSensors(processed, discreteDates);
  return sortDetailed(aggregated);
};

export {mapSensors};
